import { ChatData, ChatMessage } from "../types/global.d";
import { API_URL, fetchWithAuth } from "../utils/api";
import {
  normalizeChatMessageTextFields,
  normalizeChatsTextFields,
  normalizeChatTextFields,
} from "../utils/textNormalization";

export const getUserChats = async (): Promise<ChatData[]> => {
  const data = await fetchWithAuth(`${API_URL}/chats`, {
    method: "GET",
  });
  return normalizeChatsTextFields(data);
};

export const getChatById = async (chatId: string): Promise<ChatData> => {
  const data = await fetchWithAuth(`${API_URL}/chats/${encodeURIComponent(chatId)}`, {
    method: "GET",
  });
  return normalizeChatTextFields(data);
};

export const sendMessage = async (
  chatId: string,
  content: string,
  messageType: "text" | "system" = "text"
): Promise<ChatMessage> => {
  const data = await fetchWithAuth(`${API_URL}/chats/${encodeURIComponent(chatId)}/messages`, {
    method: "POST",
    body: JSON.stringify({ content, messageType }),
  });
  return normalizeChatMessageTextFields(data);
};

export const markMessagesAsRead = async (chatId: string): Promise<void> => {
  await fetchWithAuth(`${API_URL}/chats/${encodeURIComponent(chatId)}/read`, {
    method: "PUT",
    body: JSON.stringify({}),
  });
};

export const ensureAdminChatWithNickname = async (
  nickname: string
): Promise<ChatData> => {
  const data = await fetchWithAuth(
    `${API_URL}/chats/admin/with-nick/${encodeURIComponent(nickname)}`,
    {
      method: "GET",
    }
  );
  return normalizeChatTextFields(data);
};
